<template>
  <v-container>
    <v-card v-if="selectedDashboard.hasWinnerList">
      <v-layout column>
        <v-flex style>
          <v-row class="optionsBox">
            <v-col>
              <v-autocomplete
                v-model="raffleType"
                :items="raffleTypes"
                item-text="name"
                item-value="value"
                label="Select Raffle Type"
              >
              </v-autocomplete>
            </v-col>
            <v-col v-if="getCampaignId">
              <v-autocomplete
                v-model="selectedCampaignId"
                :items="selectableCampaigns"
                item-text="text"
                item-value="symbol"
                label="Select Campaign Id"
              >
              </v-autocomplete>
            </v-col>
            <v-col>
              <date-picker
                required
                v-if="raffleType != 'all'"
                icon="mdi-calendar"
                label="Start Date"
                v-model="startDate"
                writable
              ></date-picker>
              <date-picker
                required
                v-if="raffleType != 'all'"
                icon="mdi-calendar"
                label="End Date"
                v-model="endDate"
                writable
              ></date-picker>
            </v-col>
            <v-col>
              <v-row>
                <v-btn
                  class="button"
                  color="blue darken-2"
                  @click="getWinnerList()"
                  >Search
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
          <v-data-table
            :items="winnerList"
            :no-data-text="'Receipts no DataText'"
            :disable-pagination="true"
            :hide-default-footer="true"
            :headers="headers"
            :loading="isLoading"
          >
            <template slot="item" slot-scope="{ item }">
              <tr>
                <td>{{ item.coupon_fk }}</td>
                <td>{{ item.firstName }}</td>
                <td>{{ item.lastName }}</td>
                <td>{{ item.raffleType }}</td>
                <td>{{ item.referenceNumber }}</td>
                <td>{{ formattedDate(item.createdAt) }}</td>
              </tr>
            </template>

            <template slot="no-data">
              <v-alert
                :value="true"
                icon="mdi-cancel"
                class="display-1 font-weight-thin"
                >No Winner found for now ¯\_(ツ)_/¯</v-alert
              >
            </template>
            <template slot="footer"></template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-card>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
import axios from "axios";
import DatePicker from "../components/DatePicker.vue";

export default {
  components: {
    DatePicker
  },
  data() {
    return {
      headers: [
        {
          sortable: false,
          text: "Coupon Id",
          value: "coupon_fk"
        },
        {
          sortable: false,
          text: "Name",
          value: "firstName"
        },
        {
          sortable: false,
          text: "Surname",
          value: "lastName"
        },
        {
          sortable: false,
          text: "Raffle Tpye",
          value: "raffleType"
        },
        {
          sortable: false,
          text: "Reference Number",
          value: "referenceNumber"
        },
        {
          sortable: false,
          text: "createdAt",
          value: "createdAt"
        }
      ],
      raffleTypes: [
        {
          name: "All Winners",
          value: "all"
        },
        {
          name: "Weekly Raffle",
          value: "weekly"
        },
        {
          name: "Final Raffle",
          value: "final"
        }
      ],
      winnerList: [],
      isLoading: true,
      startDate: moment().subtract(1, "days"),
      endDate: moment(),
      selectableCampaigns: [],
      selectedCampaignId: "",
      raffleType: "all"
    };
  },
  computed: {
    ...mapGetters(["userToken", "selectedDashboard"]),
    getCampaignId: {
      get() {
        if (this.selectedDashboard.campaignId === "pg-template") {
          this.selectableCampaigns = [];
        } else if (this.selectedDashboard.campaignId === "pg-ro") {
          this.selectableCampaigns = [{ text: "pg-charity-ro", value: "pg-charity-ro" }];
        } else if (this.selectedDashboard.campaignId === "pg-turkey") {
          this.selectableCampaigns = [];
        }
        return true;
      }
    }
  },
  methods: {
    ...mapActions(['errorHandler']),
    getWinnerList() {
      const method = "post";
      const url = `${this.selectedDashboard.endPoints.base}/getWinnerUsers`;
      const data = {
        sessid: this.userToken,
        campaignId: this.selectedCampaignId,
        startDate: this.startDate,
        endDate: this.endDate,
        raffleType: this.raffleType
      };
      axios({ method, url, data })
        .then((response) => {
          if (response.data.response) {
            this.winnerList = response.data.winnerList;
            this.isLoading = false;
          } else {
            this.errorHandler(response.data.message || response.data.error)
          }
        })
        .catch((er) => {
          this.errorHandler(er.response)
        });
      return true;
    },
    formattedDate(date) {
      return moment(date).format("DD/MM/YYYY HH:mm");
    }
  },
  mounted() {
    if ("name" in this.selectedDashboard === false) {
      const dashboard = JSON.parse(localStorage.selectedDashboard);
      this.$store.commit("setDashboard", dashboard);
    }
    this.$store.commit("setUserRoles", JSON.parse(localStorage.userRoles));
  }
};
</script>

<style scoped>
            .optionsBox {
  margin-left: 25px;
  margin-right: 25px;
  margin-top: 25px;
}
</style>
